import React, { PropsWithChildren, useEffect, useState } from 'react'
import {
  DropDownListBlurEvent,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import DropdownOption from './DropdownOption';
import SearchableDropdown from './SearchableDropdown';
import { RegionService } from '../../services';
import { RegionModel } from '../../data/entities';

interface SearchableRegionDropdownProps extends PropsWithChildren {
  value?: any;
  name: string;
  isInvalid?: boolean;
  onBlur?: (e: DropDownListBlurEvent) => void;
  onChange?: (e: DropDownListChangeEvent) => void;
  onSelect?: (value: DropdownOption) => void;
  placeholder?: string;
  disabled?: boolean;
}

export const SearchableRegionDropdown = React.forwardRef(
  (
    props: Readonly<SearchableRegionDropdownProps>,
    ref: React.ForwardedRef<HTMLSelectElement | null>
  ) => {
    const regionService = new RegionService();
    const [options, setOptions] = useState<DropdownOption[]>([]);

    useEffect(() => {
      const fetchData = async () => {
        let regions = await regionService.getAll();

        const newOptions = regions.map<DropdownOption>((region: RegionModel) => ({
          value: region.id?.toString() ?? "",
          text: `${region.name}`,
        }));

        setOptions(newOptions);
      };

      fetchData();
    }, []);

    const getValue = () => {
      if (props.value) {
        return options.find((option) => option.value === props.value?.toString());
      }
    }

    return (
      <SearchableDropdown
        label="Region"
        name={props.name}
        options={options}
        value={getValue()}
        onChange={props.onChange}
        onSelect={props.onSelect}
        isInvalid={props.isInvalid}
        disabled={props.disabled}
      >
        {props.children}
      </SearchableDropdown>
    );
  }
);

export default SearchableRegionDropdown
